<template>
  <div class="card form-card">
    <div v-if="showTitle" class="form-card-header px-i" :class="{ 'form-card-header-nowrap': headerNoWrap }">
      <div class="form-card-header-title">
        <BoolRadioControl
          @input="setSelected($event)"
          name="resource_id"
          :label="formTitle"
          :value="selectedId"
          :used-value="resource.id" />
      </div>
      <slot name="header-end" />
    </div>
    <div v-if="showBody" class="card-body form-card-body" :class="{ 'px-i': !noPadding, 'p-0': noPadding }">
      <slot />
    </div>
  </div>
</template>

<script>
import BoolRadioControl from "./BoolRadioControl.vue";

import { humanize, titleize } from "../../helpers";

export default {
  props: {
    resource: { type: Object },
    showBody: { type: Boolean, default: false },
    sectionTitle: { type: String, default: null },
    showTitle: { type: Boolean, default: true },
    noPadding: { type: Boolean, default: false },
    headerNoWrap: { type: Boolean, default: true },
    selectedId: { type: Number }
  },

  components: {
    BoolRadioControl
  },

  computed: {
    formTitle () {
      if (this.sectionTitle) {
        return this.sectionTitle;
      }
    }
  },

  methods: {
    setSelected (e) {
      this.$emit("setSelected", e);
    }
  }
};
</script>
